export default __webpack_public_path__ + "static/media/Integrated Sensor System.e903bc48.pdf";